import legalDocuments from "../../../../config/legal_documents.json"

export const TERMS_OF_SERVICE_METADATA = legalDocuments.terms_of_service
export const PRIVACY_POLICY_METADATA = legalDocuments.privacy_policy
